import {
    GENERAL_INFORMATION_READY,
    EXPRESS_CONFIGURATION_READY,
    CREATE_USER_REQUEST,
    CREATE_USER_SUCCESS,
    CREATE_USER_FAILURE,
    GET_USERS_REQUEST,
    GET_USERS_SUCCESS,
    GET_USERS_FAILURE,
    GET_USER_REQUEST,
    GET_USER_SUCCESS,
    GET_USER_FAILURE,
    CLEAN_USERS,
    CLEAN_USER,
    SET_TOTAL_USERS,
    DELETE_USER_REQUEST,
    DELETE_USER_SUCCESS,
    DELETE_USER_FAILURE,
    GET_TELEPHONY_PROFILES_REQUEST,
    GET_TELEPHONY_PROFILES_SUCCESS,
    GET_TELEPHONY_PROFILES_FAILURE,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAILURE,
    COPY_IP
} from './userActionTypes';

export const generalInformationReady = (status, data) => ({
    type: GENERAL_INFORMATION_READY,
    payload: {
        status,
        data
    }
});

export const expressConfigurationReady = (status, data) => ({
    type: EXPRESS_CONFIGURATION_READY,
    payload: {
        status,
        data
    }
});

export const createUserRequest = history => ({
    type: CREATE_USER_REQUEST,
    payload: { history }
});

export const createUserSuccess = () => ({ type: CREATE_USER_SUCCESS });

export const createUserFailure = () => ({
    type: CREATE_USER_FAILURE,
    payload: new Error(),
    error: true
});

export const getUsersRequest = (total, offset, searchText) => ({
    type: GET_USERS_REQUEST,
    payload: { total, offset, searchText }
});

export const getUsersSuccess = users => ({
    type: GET_USERS_SUCCESS,
    payload: { users }
});

export const getUsersFailure = () => ({ type: GET_USERS_FAILURE });

export const getUserRequest = id => ({
    type: GET_USER_REQUEST,
    payload: { id }
});

export const getUserSuccess = user => ({
    type: GET_USER_SUCCESS,
    payload: { user }
});

export const getUserFailure = () => ({
    type: GET_USER_FAILURE,
    payload: new Error(),
    error: true
});

export const cleanUsers = () => ({ type: CLEAN_USERS });

export const cleanUser = () => ({ type: CLEAN_USER });

export const setTotalUsers = total => ({
    type: SET_TOTAL_USERS,
    payload: { total }
});

export const deleteUserRequest = id => ({
    type: DELETE_USER_REQUEST,
    payload: { id }
});

export const deleteUserSuccess = id => ({
    type: DELETE_USER_SUCCESS,
    payload: { id }
});

export const deleteUserFailure = id => ({
    type: DELETE_USER_FAILURE,
    payload: { id },
    error: true
});

export const getTelephonyRequest = () => ({ type: GET_TELEPHONY_PROFILES_REQUEST });

export const getTelephonySuccess = TelephonyProfiles => ({
    type: GET_TELEPHONY_PROFILES_SUCCESS,
    payload: { TelephonyProfiles }
});

export const getTelephonyFailure = () => ({
    type: GET_TELEPHONY_PROFILES_FAILURE,
    payload: new Error(),
    error: true
});

export const updateUserRequest = (id, history) => ({
    type: UPDATE_USER_REQUEST,
    payload: {
        id,
        history
    }
});

export const updateUserSuccess = () => ({ type: UPDATE_USER_SUCCESS });

export const updateUserFailure = () => ({
    type: UPDATE_USER_FAILURE,
    payload: new Error(),
    error: true
});

export const copyIP = (ip, message) => ({
    type: COPY_IP,
    payload: {
        ip,
        message
    }
});
